import { compile } from 'path-to-regexp'
import { ROUTE } from 'constants/index'
import startsWith from 'lodash/startsWith'
import { history } from './history'

export const routeHelper = {
  getRouteLink,
  getRouteForgotPassword,
  getRouteHome,
  getRouteLogin,
  getRouteMessage,
  getRouteUpdateProfile,
  getRouteIncome,
  getRouteProfile,
  getRouteJoinMeeting,
  getRouteConversation,
  getRouteClasses,
  handleRedirect,
  getRouteRequest,
}

function getRouteLink(route, data = {}) {
  try {
    const toPath = compile(route)
    return toPath(data)
  } catch (error) {
    return null
  }
}

function getRouteForgotPassword() {
  return getRouteLink(ROUTE.FORGOT_PASSWORD)
}

function getRouteHome() {
  return getRouteLink(ROUTE.HOME)
}

function getRouteLogin() {
  return getRouteLink(ROUTE.LOGIN)
}

function getRouteMessage(group) {
  return getRouteLink(ROUTE.MESSAGE, { group })
}

function getRouteConversation() {
  return getRouteLink(ROUTE.CONVERSATION)
}

function getRouteUpdateProfile() {
  return getRouteLink(ROUTE.UPDATE_PROFILE)
}

function getRouteIncome() {
  return getRouteLink(ROUTE.INCOME)
}

function getRouteProfile() {
  return getRouteLink(ROUTE.PROFILE)
}

function getRouteJoinMeeting() {
  return getRouteLink(ROUTE.JOIN_MEETING)
}

function getRouteRequest() {
  return getRouteLink(ROUTE.REQUEST)
}

function getRouteClasses(data) {
  return getRouteLink(ROUTE.CLASSES, data)
}

function handleRedirect(redirectUrl) {
  if (redirectUrl) {
    const isUrl = startsWith(redirectUrl, 'http')
    if (isUrl) {
      window.location.href = redirectUrl
    } else {
      history.replace(redirectUrl)
    }
  }
}
